import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Domain, DomainRequest } from './types'

export const domainsListMounted = createEvent<DomainRequest>()
export const syncDomainsList = createEvent()
export const deleteDomainEvent = createEvent<string>()

export const getDomains = fx<DomainRequest, Domain[]>({
  method: 'GET',
  url: `/forbidden_domain?order=-domain`,
})

export const syncDomain = fx<void, void>({
  method: 'GET',
  url: `/forbidden_domain/get_list`,
})

export const deleteDomain = fx<Domain, Domain>({
  method: 'DELETE',
  url: '/forbidden_domain/',
})

export const $domains = restore<Domain[]>(
  getDomains.doneData.map((a) => a.body),
  [],
)

sample({
  // @ts-ignore
  clock: domainsListMounted,
  fn: ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
  }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    if (searchText) {
      // @ts-ignore
      newObj[searchedColumn] = searchText.toLowerCase()
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify(newObj)}`

    return {
      query,
    }
  },
  target: getDomains,
})

sample({
  clock: syncDomainsList,
  fn: () => ({}),
  target: syncDomain,
})

sample({
  clock: deleteDomainEvent,
  fn: (id) => {
    return {
      url: `/forbidden_domain/${id}`,
    }
  },
  target: deleteDomain,
})

sample({ clock: deleteDomain.doneData, fn: () => ({}), target: getDomains })
